import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';
import { Router } from '@angular/router';
import { Trip } from '@models';
import { UtilService } from '@services';

@Component({
  selector: 'app-trips-table',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatTableModule,
    MatProgressSpinnerModule,
    MatPaginatorModule,
  ],
  templateUrl: './trips-table.component.html',
  styleUrl: './trips-table.component.scss',
})
export class TripsTableComponent {
  @Input() columns: string[] = [];
  @Input() columnLabels: Record<string, string> = {};
  @Input() trips: Trip[] = [];
  @Input() loading: boolean = true;
  @Input() totalTrips: number = 0;
  @Input() pageSize: number = 20;
  @Input() pageIndex: number = 0;

  @Output() pageChange: EventEmitter<PageEvent> = new EventEmitter<PageEvent>();

  constructor(private router: Router, public utils: UtilService) {}

  public onPageChange(e: PageEvent): void {
    this.pageChange.emit(e);
  }

  public navToTripDetails(tripId: string): void {
    this.router.navigate(['/trips', tripId]);
  }
}
